import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { permission } from "./Permissions/PermissionsSlice";

// Models
export interface role {
    id: number,
    name?: string,
    permissions?: permission[]
}

// Roles state
export interface rolesState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    roles: role[]
}

const initialRolesState: rolesState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    roles: []
}

// Roles slice
export const rolesSlice = createSlice({
    name: 'roles',
    initialState: initialRolesState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsFetching: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isFetching = payload
        },
        setHasMore: ( state, {payload}: PayloadAction<boolean> ) => {
            state.hasMore = payload
        },
        initializeRoles:(state, {payload}: PayloadAction<role[]>)=>{
            state.roles=payload
        },
        addRoles: ( state, {payload}: PayloadAction<role[]> ) => {
            state.roles = [ ...state.roles, ...payload ]
        },
        updateRole: ( state, {payload}: PayloadAction<role> ) => {
            let index = state.roles.findIndex( role => role.id === payload.id )
            if( index !== -1 )
                state.roles[index] = payload
        },
        deleteRoles: ( state, {payload}: PayloadAction<number[]> ) => {
            payload.map(id => {
                let index = state.roles.findIndex( role => role.id === id )
                if( index != -1 )
                    state.roles.splice( index, 1 )
            })
        },
        reset: ( state ) => {
            state.roles = []
            state.hasMore = true
        }
    }
})